import { Box } from '@mui/material';

import { addTourSequence } from '@/domain/project-tour-ontour/actions/add-tour-sequence.action';
import { TourSequence } from '@/domain/project-tour-ontour/entities/project-tour-ontour-sequence.entity';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { useAppDispatch } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { TourSequenceForm, TourSequenceFormInput } from './TourSequenceForm';

export function ModalTourSequenceAdd({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const dispatch = useAppDispatch();

  const onSubmit = async (data: TourSequenceFormInput) => {
    const params = { name: data.name };
    try {
      await dispatch(addTourSequence(params)).unwrap();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const emptySequence: TourSequence = {
    id: -1,
    name: '',
  };

  return (
    <FSModal open={open} onClose={onClose}>
      <FSModalTitle
        title={translate('ProjectsTour.SequenceForm.add-form-title')}
      />
      <Box sx={{ height: '1rem' }} />
      <TourSequenceForm
        sequence={emptySequence}
        onClose={onClose}
        onSubmit={onSubmit}
      />
    </FSModal>
  );
}
